class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.headerElement = document.querySelector('sticky-header header');
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');
        this.searchFooterModal = this.querySelector('#search-modal-footer');
        this.footerContentElement = document.querySelector('#footer-content').cloneNode(true);
        this.footerContentElement
            .querySelector('#footer-first-grid-col')
            .setAttribute('id', '#search-footer-first-grid-col');
        this.footerContentElement
            .querySelector('#footer-last-grid-col')
            .setAttribute('id', '#search-footer-last-grid-col');
        this.footerContentElement.setAttribute('id', 'search-footer-content');
        this.footer = document.querySelector('#footer');

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );
        this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
        this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }

    onBodyClick(event) {
        if (!this.contains(event.target) && !this.headerElement.contains(event.target)) this.close(false);
    }

    open(event) {
        this.searchFooterModal.appendChild(this.footerContentElement);
        this.headerElement.classList.add('xbg-secondary');
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.querySelector('.side-navigator')?.classList.add('xhidden');
        // document.body.classList.add('overflow-hidden');
        toggleBodyScroll(false);

        trapFocus(
            this.detailsContainer.querySelector('[tabindex="-1"]'),
            this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
    }

    close(focusToggle = true) {
        this.headerElement.classList.add('xbg-secondary');
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.headerElement.classList.remove('xbg-secondary');
        this.classList.add('animate-fade-out');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.querySelector('.side-navigator')?.classList.remove('xhidden');
        setTimeout(() => {
            this.detailsContainer.removeAttribute('open');
            this.classList.remove('animate-fade-out');
            toggleBodyScroll(true);
        }, 200);
    }
}

customElements.define('details-modal', DetailsModal);
